import { Component, h, Prop, getAssetPath, EventEmitter } from '@stencil/core'
import { retailSearchResultsPage, coveoAnalyticsApiUrl, profileLinkApiUrl } from 'src/global/resources'
import { postData, fetchData } from 'src/utils/http-requests.util'
import { CoveoAnalytics } from 'src/model/coveo-analytics.model'
import { AutosuggestResult } from 'src/model/autosuggest.model'

@Component({
  tag: 'tradelab-search-dropdown',
  styleUrl: 'tradelab-search-dropdown.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class TradelabSearchDropdown {
  @Prop() recentSearches: string[] = []
  @Prop() handleUpdateRecentSearches: (expression: string) => void
  @Prop() autosuggest!: AutosuggestResult[] | null
  @Prop() searchQuery = ''
  @Prop() previousNavigationEvent: EventEmitter<string>
  @Prop() createSearchClickObject: (searchTermClicked: string, searchType: string) => void
  @Prop() postCoveoAnalyticsBody: CoveoAnalytics
  @Prop() dropdownMaxItems!: number

  private async handleOnClickProduct(productSummary: string) {
    const postCoveoAnalyticsBody: CoveoAnalytics = {
      user: 'sxp-web-component',
      eventType: 'ProductListHeader',
      eventValue: 'onClick',
      language: 'en',
      originLevel1: 'RetailSearchHub',
      customData: {
        selectedProduct: productSummary,
      },
    }
    // call analytics api here
    postData<CoveoAnalytics>(coveoAnalyticsApiUrl, postCoveoAnalyticsBody)
      .catch(err => console.error('CoveoAnalyticsError', err))

    try {
      // fetching the profile link which redirect to investment products page
      const res = await fetchData<Record<string, string>>(profileLinkApiUrl, encodeURIComponent(productSummary))
      window.location.assign(res.profileLink)
    } catch (error) {
      console.error('FetchProfileLinkError', error)
    }
    this.createSearchClickObject(productSummary, 'autosuggest click - product')
  }

  private handleOnClickSuggestion(expression: string) {
    try {
      const encodeURL = encodeURI(expression)
      this.handleUpdateRecentSearches(expression)
      this.previousNavigationEvent.emit('backArrow')
      window.location.assign(`${retailSearchResultsPage}${encodeURL}`)
    } catch (error) {
      console.error(error)
    }
    this.createSearchClickObject(expression, 'autosuggest click')
  }

  render() {
    const searchQueryReg = new RegExp(this.searchQuery, 'gi')
    if (this.autosuggest) {
      return (
        <div
          role="menu"
          id="searchWidgetDropdown"
          class="search-widget-dropdown c11n-dropdown__menu c11n-menu__menu c11n-elevation-800"
        >
          <div class="search-widget-dropdown-list search-widget-text">
            <div role="group" aria-label="Product List" class="products-list">
              {this.autosuggest.slice(0, this.dropdownMaxItems).map((suggestion) => {
                const name = suggestion.name.replace(`(${suggestion.tickerSymbol})`, '').trim()
                return (
                  <button
                    role="menuitem"
                    class="search-widget-dropdown-list-item search-widget-text"
                    onClick={() => this.handleOnClickProduct(`${suggestion.tickerSymbol} - ${suggestion.name}`)}
                  >
                    <b class="product-name">{suggestion.tickerSymbol}</b>
                    <p innerHTML={name.replace(searchQueryReg, str => '<b>' + str + '</b>')}></p>
                  </button>
                )
              })}
            </div>
          </div>
        </div>
      )
    } else if (this.searchQuery.length === 0 && this.recentSearches.length > 0) {
      return (
        <div
          role="menu"
          id="searchWidgetDropdown"
          class="search-widget-dropdown c11n-dropdown__menu c11n-menu__menu c11n-elevation-800"
        >
          <div class="search-widget-dropdown-list">
            <div class="search-widget-dropdown-listname search-widget-text"><b>Recent searches</b></div>
            <div role="group" aria-label="Recent Searches List">
              {this.recentSearches.map(item => (
                <button
                  role="menuitem"
                  class="search-widget-dropdown-list-item search-widget-text"
                  onClick={() => this.handleOnClickSuggestion(item)}
                >
                  <img src={getAssetPath('./assets/rewind.png')} width={14} height={14} alt="recent search" />
                  <p>{item}</p>
                </button>
              ))}
            </div>
          </div>
          <hr />
          <div class="search-widget-dropdown-list search-widget-text hidden" />
        </div>
      )
    }
  }
}
